<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-layer-group"></i> Glass Offcuts
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <DataTable
          :columns="columnList"
          defaultColumnOrderDir="ASC"
          :defaultColumnOrderIndex="3"
          :url="dataURL"
          :filterOptions="offcutFilterOptions"
          :displayTools="true"
          :hasDateRangeFilter="true"
          :displayExportTools="true"
          exportTitle="Glass Offcuts"
        >
          <template v-slot:title>
            <h3>Glass Offcut List</h3>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td>
                {{row.data.barcode}}
              </td>
              <td>
                {{row.data.height}} x {{row.data.width}}
              </td>
              <td>
                {{formatDecimal(row.data.totalOnHandSquareMetres, 2, true)}}m&sup2;
              </td>
              <td>
                {{formatCurrency(row.data.totalOnHandValue)}}
              </td>
              <td>
                <LinkStock :id="row.data.stockId" :name="row.data.stockName" />
              </td>
              <td>
                {{formatHyphenEmptyValue(row.data.inventoryBinCode)}}
              </td>
              <td>
                {{formatHyphenEmptyValue(row.data.accountLocationName)}}
              </td>
              <td>
                {{formatDateTime(row.data.createdAt)}}
              </td>
              <td>
                <ActionDropMenu :tableAction="true" :forceDropdown="true">
                  <DropdownMenuItem @click="printGlassOffcutLabel(row.data)" icon="fa-print">Print Offcut Label</DropdownMenuItem>
                </ActionDropMenu>
              </td>
            </tr>
          </template>
          <template v-slot:summary="summary">
            <tr key="summary">
              <td>Total: {{summary.data.totalQuantity}}</td>
              <td></td>
              <td>{{formatDecimal(summary.data.totalSquareMetres, 2, true)}}m&sup2;</td>
              <td>{{formatCurrency(summary.data.totalValue)}}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </DataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import { mapState } from "vuex"

import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"

import { InventoryStockTypes, InventoryStockTypeLookup } from '@/store/types'

export default {
  name: 'GlassOffcutList',
  components: {
    TabbedBox,
    Tab,
    TabPage
  },
  props: {
    filterType: String
  },
  created() {
    this.InventoryStockTypeLookup = InventoryStockTypeLookup
  },
  computed: {
    ...mapState({
      accountLocations: state => state.account.accountLocations
    }),
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        includesummary: true,
        filter: {
          isOffcut: 1,
          isOffcutAvailable: 1,
          isActive: 1
        }
      }
      return '/inventory/glasslevels?' + $.param(params)
    },
    offcutFilterOptions() {
      var filterOptions = []

      filterOptions.push({
        name: 'Location',
        field: 'accountLocationId',
        options: (this.accountLocations || []).filter(location => location.isActive).map(location => {
          return {
            name: location.name,
            value: location.id,
            class: 'label-misc'
          }
        })
      })

      return filterOptions
    }
  },
  data: () => {
    return {
      columnList: [
        { title: "Barcode", data: "id" },
        { title: "Size", data: "size", sortable: false },
        { title: "Square Metres", data: "totalOnHandSquareMetres" },
        { title: "Stock Value", data: "totalOnHandValue", type: 'currency' },
        { title: "Stock", data: "stockName" },
        { title: "Bin", data: "inventoryBinCode" },
        { title: "Location", data: "accountLocationName" },
        { title: "Creation Date", data: "createdAt", dateFilter: true, type: 'datetime' },
        { title: "Actions", data: "", sortable: false, export: false }
      ]
    }
  },
  mounted() {
  },
  methods: {
    printGlassOffcutLabel(glassLevel) {
      this.$apiService.inventoryService.generatePrintOffcutLabelURL(glassLevel.id, { download: true, label: true })
      .then(response => {
        window.location.href = response.data.url
      })
      .catch(err => {
        console.error(err)
        this.displayNetworkError(err, 'Print Error')
      })
    },

  }
};
</script>
